"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCeloInternal = exports.useContractKit = exports.useCelo = void 0;
var react_celo_provider_1 = require("./react-celo-provider");
function useCelo() {
  var _ref = (0, react_celo_provider_1.useReactCeloContext)(),
    _ref2 = _slicedToArray(_ref, 3),
    reducerState = _ref2[0],
    _dispatch = _ref2[1],
    celoMethods = _ref2[2];
  var dapp = reducerState.dapp,
    address = reducerState.address,
    network = reducerState.network,
    walletChainId = reducerState.walletChainId,
    feeCurrency = reducerState.feeCurrency,
    connectorInitError = reducerState.connectorInitError,
    networks = reducerState.networks,
    connector = reducerState.connector;
  var destroy = celoMethods.destroy,
    disconnect = celoMethods.disconnect,
    updateNetwork = celoMethods.updateNetwork,
    connect = celoMethods.connect,
    getConnectedKit = celoMethods.getConnectedKit,
    performActions = celoMethods.performActions,
    updateFeeCurrency = celoMethods.updateFeeCurrency,
    contractsCache = celoMethods.contractsCache,
    updateTheme = celoMethods.updateTheme;
  return {
    dapp: dapp,
    address: address,
    network: network,
    walletChainId: walletChainId,
    feeCurrency: feeCurrency,
    initError: connectorInitError,
    // Copy to ensure any accidental mutations dont affect global state
    networks: networks.map(function (net) {
      return Object.assign({}, net);
    }),
    kit: connector.kit,
    // the wallet address from Account.getWalletAddress => The address at which the account expects to receive transfers.
    // If it's empty/0x0, the account indicates that an address exchange should be initiated with the dataEncryptionKey
    /*
     * @deprecated this will likely be removed in favor of just address
     */
    account: connector.kit.connection.defaultAccount,
    initialised: connector.initialised,
    walletType: connector.type,
    supportsFeeCurrency: connector.supportsFeeCurrency(),
    destroy: destroy,
    disconnect: disconnect,
    updateNetwork: updateNetwork,
    connect: connect,
    getConnectedKit: getConnectedKit,
    performActions: performActions,
    updateFeeCurrency: updateFeeCurrency,
    contractsCache: contractsCache,
    updateTheme: updateTheme
  };
}
exports.useCelo = useCelo;
/**
 * @deprecated Use the alias {@link useCelo} hook instead.
 */
exports.useContractKit = useCelo;
/**
 * @internal useCelo with internal methods exposed. Package use only.
 */
var useCeloInternal = function useCeloInternal() {
  var _ref3 = (0, react_celo_provider_1.useReactCeloContext)(),
    _ref4 = _slicedToArray(_ref3, 3),
    _ref4$ = _ref4[0],
    pendingActionCount = _ref4$.pendingActionCount,
    connectionCallback = _ref4$.connectionCallback,
    theme = _ref4$.theme,
    manualNetworkMode = _ref4$.manualNetworkMode,
    _dispatch = _ref4[1],
    _ref4$2 = _ref4[2],
    initConnector = _ref4$2.initConnector,
    resetInitError = _ref4$2.resetInitError;
  return Object.assign(Object.assign({}, useCelo()), {
    manualNetworkMode: manualNetworkMode,
    connectionCallback: connectionCallback,
    initConnector: initConnector,
    pendingActionCount: pendingActionCount,
    theme: theme,
    resetInitError: resetInitError
  });
};
exports.useCeloInternal = useCeloInternal;